function initializeFadeInObserver(root = document) {
  const images = root.querySelectorAll(".fade-in");

  if (!images.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");

        const parentAnimation = entry.target.closest(".js-aos-animation");
        if (parentAnimation && !parentAnimation.classList.contains("active")) {
          parentAnimation.classList.add("active");
        }

        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  images.forEach((img) => observer.observe(img));
}

document.addEventListener('DOMContentLoaded', () => {
  initializeFadeInObserver(document);
});

document.addEventListener('DOMContentLoaded', function () {
  const lazyVideos = document.querySelectorAll('.js-lazy-video');

  function forcePlay(video) {
    video.muted = true;
    video.play().then(() => {
      setTimeout(() => {
        video.play().catch(err => {
          console.log('Second play() failed:', err);
        });
      }, 100);
    }).catch(err => {
      console.log('First play() failed:', err);
    });
  }

  function loadVideoSources(video) {
    const sources = video.querySelectorAll('source');
    let hasLoaded = false;

    sources.forEach(source => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
        hasLoaded = true;
      }
    });

    if (hasLoaded) {
      video.load();
    }
  }

  function handleVideo(video) {
    loadVideoSources(video);
    video.controls = false;

    if (video.hasAttribute('autoplay')) {
      forcePlay(video);
    }

    const parentAnimation = video.closest('.js-aos-animation');
    if (parentAnimation) {
      parentAnimation.classList.add('active');
    }
  }

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          handleVideo(entry.target);
          videoObserver.unobserve(entry.target);
        }
      });
    });

    lazyVideos.forEach(video => videoObserver.observe(video));
  } else {
    lazyVideos.forEach(handleVideo);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll('.js-video-wrapper');

  const muteAllVideos = () => {
    wrappers.forEach((w) => {
      const video = w.querySelector('.js-lazy-video');
      const iconMute = w.querySelector('.js-icon-mute');
      const iconUnmute = w.querySelector('.js-icon-unmute');

      if (video) video.muted = true;
      if (iconMute && iconUnmute) {
        iconMute.style.display = "block";
        iconUnmute.style.display = "none";
      }
    });
  };

  wrappers.forEach((wrapper) => {
    const video = wrapper.querySelector('.js-lazy-video');
    const btn = wrapper.querySelector('.js-video-sound-btn');
    const iconMute = wrapper.querySelector('.js-icon-mute');
    const iconUnmute = wrapper.querySelector('.js-icon-unmute');

    if (!video || !btn || !iconMute || !iconUnmute) return;

    video.muted = true;
    iconMute.style.display = "block";
    iconUnmute.style.display = "none";

    const updateIcons = () => {
      if (video.muted) {
        iconMute.style.display = 'block';
        iconUnmute.style.display = 'none';
      } else {
        iconMute.style.display = 'none';
        iconUnmute.style.display = 'block';
      }
    };

    btn.addEventListener('click', (e) => {
      e.stopPropagation();

      const isCurrentlyUnmuted = !video.muted;

      if (isCurrentlyUnmuted) {
        video.muted = true;
        updateIcons();
        return;
      }

      muteAllVideos();
      video.muted = false;
      video.play();
      updateIcons();
    });

    wrapper.addEventListener("click", (e) => {
      if (e.target.closest(".js-video-sound-btn")) return;

      const isCurrentlyUnmuted = !video.muted;

      if (isCurrentlyUnmuted) {
        video.muted = true;
        updateIcons();
        return;
      }

      muteAllVideos();
      video.muted = false;
      video.play();
      updateIcons();
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest('.js-video-wrapper')) {
      muteAllVideos();
    }
  });
});